import { useSelector } from 'react-redux';
import { Card, VariantTable } from 'modules/experiments/components/ui';
import { MONITOR_CARD_HEIGHT } from 'modules/experiments/constants';
import { VariantBreakdownCardProps } from 'modules/experiments/types';
import {
  getExperimentLoadingState,
  getExperimentStateStatus,
} from 'modules/experiments/ducks/selectors';
import {
  useExperimentsTranslations,
  useMetricsTranslations,
  useSelectedMetricsColumn,
} from 'modules/experiments/hooks';
import { getVariantBreakdownTableColumnData } from 'modules/experiments/utils';
import { reactNodeToString } from 'utils/reactHelpers';

import { CardHeader } from './Header';
import { CardWrapper } from './Styled';

export const VariantBreakdown = ({
  options,
  metricMap,
  variantList,
}: VariantBreakdownCardProps) => {
  const state = useSelector(getExperimentStateStatus);
  const winningCriteriaName = reactNodeToString(
    options.filter(({ doubleLine }) => !!doubleLine)[0]?.label,
  );
  const { t: experimentsT } = useExperimentsTranslations();
  const { t: metricsT, i18n } = useMetricsTranslations();
  const { defaultMetricColumns, selectedMetricsColumn, setSelectedMetricsColumn } =
    useSelectedMetricsColumn();
  const loading = useSelector(getExperimentLoadingState);
  const columns = getVariantBreakdownTableColumnData({
    experimentsT,
    metricsT,
    i18n,
    defaultMetricColumns,
    selectedMetricsColumn,
    metricMap,
    winningCriteriaName,
    state,
  });

  return (
    <Card
      testId="variant-breakdown"
      cardHeader={
        <CardHeader
          rows={variantList}
          loading={loading}
          options={options}
          metricMap={metricMap}
          selectedMetricsColumn={selectedMetricsColumn}
          setSelectedMetricsColumn={setSelectedMetricsColumn}
        />
      }
      loading={loading}
      height={MONITOR_CARD_HEIGHT.VARIANT_BREAKDOWN}
    >
      <CardWrapper>
        <VariantTable columns={columns} rows={variantList} />
      </CardWrapper>
    </Card>
  );
};
